/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Utils component
import TextError from "utils/TextError";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// Dashboard example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// Router components
import { useNavigate } from "react-router-dom";

// @mui material components
import Alert from "@mui/material/Alert";
import Backdrop from "@mui/material/Backdrop";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";
import Icon from "@mui/material/Icon";

// Functions from store
import {
  createDynamicColumn,
  getDynamicColumn,
  getStatus,
  getSubModulesByRoleId,
  resendVendorRegistrationLink,
  updateEmail,
} from "../../store";

// Notification
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Cookies
import EditButton from "components/standardized-components/EditButton";
import StandardButton from "components/standardized-components/StandardButton";
import ViewButton from "components/standardized-components/ViewButton";
import { addMinutes, format } from "date-fns";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const styleForEdit = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  // height: 235,
  // border: "2px solid #000",
  boxShadow: 24,
  p: 0,
  pt: 3,
};

const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const Status = ({
  getStatus,
  statusReducer,
  resendVendorRegistrationLink,
  resendVendorRegistrationLinkReducer,
  getSubModulesByRoleIdReducer,
  updateEmail,
  updateEmailReducer,
  getDynamicColumn,
  createDynamicColumn,
  getDynamicColumnReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  let userId = loginDetails?.data?.userId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  const subModuleId = "ad6289a6-415c-4df0-94c3-66a64b1c08a8";

  let dynamicColumnDetails = cookies.get("dynamic-column-data");

  let statusModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "ad6289a6-415c-4df0-94c3-66a64b1c08a8",
  );
  let resendFormLink = statusModule
    ? statusModule.actionId.includes("14f973c2-823b-4c24-9c16-4d92b63a3b18")
    : null;
  let viewVendors = statusModule
    ? statusModule.actionId.includes("9fc1c818-2d04-4fed-8793-eb3120532b06")
    : null;

  let viewVendorForm = statusModule
    ? statusModule.actionId.includes("22295bf6-08ef-4620-b828-e8d3bd72eb3b")
    : null;

  let acceptAndCreateVendors = statusModule
    ? statusModule.actionId.includes("")
    : null;
  let rejectAndResendVendors = statusModule
    ? statusModule.actionId.includes("")
    : null;
  let editEmail = statusModule
    ? statusModule.actionId.includes("86c02e3a-611a-4856-988e-16ac9b8b4855")
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");
  const [uncheck, setUncheck] = useState(false);

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };

  const statusOptions = [
    {
      label: "All Status",
      value: "",
    },
    {
      label: "Invited",
      value: 0,
    },
    {
      label: "Form Filled",
      value: 1,
    },
  ];

  const navigate = useNavigate();
  useEffect(() => {
    viewVendors && getStatus(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [viewVendors, pageNo, rowsPerPage, searchObject]);

  const viewFunction = (data) => {
    navigate(`/status/${data.vendorUserId}`);
  };

  const [state, setState] = useState({
    columns: [
      { Header: "Supplier Name", accessor: "vendorName" },
      { Header: "Contact Person", accessor: "contactPerson" },
      { Header: "Email", accessor: "email" },

      {
        Header: "Status",
        accessor: "isFilled",
        searchType: "select",
        selectOptions: statusOptions,
        placeholder: "All Status",
      },
      {
        Header: "Created Date",

        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
      {
        Header: "Action",
        accessor: "action",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });
  const { columns, rows } = state;

  const [openResendLinkModal, setOpenResendLinkModal] = useState(false);
  const [singleDataForResendLinkModal, setSingleDataForResendLinkModal] =
    useState({});
  const handleOpenResendLinkModal = (Data = {}) => {
    setSingleDataForResendLinkModal(Data);
    setOpenResendLinkModal(true);
  };
  const handleCloseResendLinkModal = () => {
    setOpenResendLinkModal(false);
  };

  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const [updateErrorMsg, setUpdateErrorMsg] = useState("");

  const [openEditEmailModal, setOpenEditEmailModal] = useState(false);

  const [singleEmailForUpdate, setSingleEmailForUpdate] = useState({});

  const handleOpenEditEmailModal = (Data = {}) => {
    setSingleEmailForUpdate(Data);
    setOpenEditEmailModal(true);
    setIsErrorForUpdate(false);
    setIsSuccessForUpdate(false);
  };

  const handleCloseEditEmailModal = () => {
    setOpenEditEmailModal(false);
  };

  const initialValues = {
    vendorId: singleEmailForUpdate.vendorId
      ? singleEmailForUpdate.vendorId
      : "",
    email: singleEmailForUpdate.email ? singleEmailForUpdate.email : null,
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email format")
      .required("Enter the E-mail!"),
  });

  const [emailButtonName, setEmailButtonName] = useState("Submit");

  const onSubmitForUpdateEmail = async (values) => {
    setEmailButtonName("Please wait...");
    let payload = {
      email: values.email.trim(),
      vendorId: `${singleEmailForUpdate?.vendorUserId}`,
    };
    let response = await updateEmail(payload, jwtToken);

    if (response.status) {
      handleCloseEditEmailModal();
      getStatus(pageNo, rowsPerPage, searchObject, jwtToken);
      setIsSuccessForUpdate(true);
      setSingleEmailForUpdate({});
      setTimeout(() => {
        setEmailButtonName("Submit");
      }, 2250);
    }
    if (!response.status) {
      setUpdateErrorMsg(response?.data?.data?.msg);
      setIsErrorForUpdate(true);
      setEmailButtonName("Submit");
    }
  };

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: onSubmitForUpdateEmail,
    validationSchema: validationSchema,
    enableReinitialize: true,
  });

  const resendLinkNotification = () =>
    toast.success("Supplier Registration Link Send Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const [isErrorResendLink, setIsErrorResendLink] = useState(false);

  useEffect(() => {
    if (isErrorResendLink) {
      setTimeout(() => {
        setIsErrorResendLink(false);
      }, 3000);
    }
  }, [isErrorResendLink]);

  const [resendButtonName, setResendButtonName] = useState("Resend");
  const [resendMsgButtonName, setResendMsgButtonName] = useState("");

  const handleResendLink = async () => {
    setResendButtonName("Please wait...");
    let payload = {
      vendorUserId: singleDataForResendLinkModal.vendorUserId,
    };
    const res = await resendVendorRegistrationLink(payload, jwtToken);
    if (res.status) {
      handleCloseResendLinkModal();
      setTimeout(() => {
        getStatus(pageNo, rowsPerPage, searchObject, jwtToken);
        resendLinkNotification();
      }, 0);
      setTimeout(() => {
        setResendButtonName("Resend");
      }, 2250);
    }
    if (!res.status) {
      setResendButtonName("Resend");
      setIsErrorResendLink(true);
      setResendMsgButtonName(res.data.data.error);
    }
  };

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let tempStatus = [];
    let usersData = statusReducer.statusData.data
      ? statusReducer.statusData.data
      : [];

    setPaginationObj(statusReducer?.statusData?.pagination);
    setLoading(statusReducer.loading);
    usersData.map((user) => {
      const formatDate = new Date(user.cd);
      const singleUser = {
        privateKey: user.email,
        vendorName: user.vendorName,
        contactPerson: user.contactPerson,
        email: user.email,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        cd: user.cd,
        // isFilled: (
        //   <div>{usersData && user.isFilled == true ? "Yes" : "No"}</div>
        // ),
        isFilled: (
          <button
            className={
              (user.isFilled === 1 && `status-success`) ||
              (user.isFilled === 0 && `status-warning`)
            }
            style={{ width: "6.8rem" }}
          >
            {(user.isFilled === 1 && `Form Filled`) ||
              (user.isFilled === 0 && `Invited`)}
          </button>
        ),
        action: (
          <div style={{ display: "flex" }}>
            {usersData && user.isFilled == true ? (
              <>
                <ViewButton
                  disabled={!viewVendorForm}
                  tooltip="View"
                  variant="gradient"
                  color="info"
                  iconOnly
                  type="button"
                  onClick={() => viewFunction(user)}
                  style={{ marginLeft: "0px", marginRight: "5px" }}
                >
                  <Icon>visibility_icon</Icon>
                </ViewButton>
              </>
            ) : (
              <>
                {resendFormLink && (
                  <StandardButton
                    tooltip="Resend Link"
                    variant="gradient"
                    color="primary"
                    iconOnly
                    icon="send"
                    type="button"
                    onClick={() => handleOpenResendLinkModal(user)}
                    style={{ marginLeft: "0px", marginRight: "5px" }}
                  >
                    <Icon>send</Icon>
                  </StandardButton>
                )}
              </>
            )}

            <>
              {editEmail && (
                <EditButton
                  tooltip="Edit Email"
                  variant="gradient"
                  color="success"
                  iconOnly
                  type="button"
                  onClick={() => handleOpenEditEmailModal(user)}
                  style={{ marginLeft: "5px", marginRight: "5px" }}
                >
                  <Icon>edit</Icon>
                </EditButton>
              )}
            </>
          </div>
        ),
      };
      tempStatus.push(singleUser);
    });
    setState({ ...state, rows: tempStatus });
  }, [statusReducer]);

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [dynamicColumnData, setDynamicColumnData] = useState("");

  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);
      getStatus(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  const [disableButton, setDisableButton] = useState(false);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {/* {!loading ? ( */}
      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted
                  tableSearch
                  showTotalEntries
                  noEndBorder
                  loading={loading}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25, 30],
                  }}
                  serverSidePagination
                  paginationObj={paginationObj}
                  pageNoValue={pageNo}
                  rowsPerPageValue={rowsPerPage}
                  pageNoProp={importPageNo}
                  rowsPerPageProp={importRowsPerPage}
                  searchProp={importSearch}
                  visibleColumns2={dynamicColumnData?.visibleFields}
                  dynamicColumnData={dynamicColumnData}
                  options={{ draggable: false }}
                  handleOpenCreateColumnReorderModal={
                    handleOpenCreateColumnReorderModal
                  }
                  subModuleId={subModuleId}
                  userId={userId}
                  disableButton={disableButton}
                />
              </MDBox>

              <Modal
                open={openCreateColumnReorderModal}
                onClose={handleCloseCreateColumnReorderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ backdropFilter: "blur(5px)" }}
              >
                <MDCard sx={styleForColumnReorder}>
                  <MDTypography>Are you sure you want to submit?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      style={{ width: "10rem", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreateColumnReorderModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "10rem", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={handleDynamicColumn}
                      // disabled={denyButtonName === "Please wait..."}
                    >
                      Submit
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessColumnReorder}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Data updated successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorColumnReorder}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForColumnReorder}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>
              <Modal
                open={openResendLinkModal}
                onClose={handleCloseResendLinkModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Card sx={style}>
                  <MDTypography mb={2}>
                    Are you sure you want to Resend Supplier Registration Link ?
                  </MDTypography>
                  <MDCard mt={2}>
                    <div style={{ display: "flex" }}>
                      <div>
                        <MDButton
                          style={{ width: "100%", marginRight: "0.5rem" }}
                          color="secondary"
                          variant="contained"
                          onClick={handleCloseResendLinkModal}
                        >
                          Cancel
                        </MDButton>
                      </div>
                      <div style={{ float: "right" }}>
                        <MDButton
                          style={{ width: "100%", marginLeft: "0.5rem" }}
                          color="warning"
                          onClick={handleResendLink}
                          disabled={resendButtonName === "Please wait..."}
                        >
                          {resendButtonName}
                        </MDButton>
                      </div>
                    </div>
                  </MDCard>
                  <MDCard mt={2}>
                    <Collapse in={isErrorResendLink}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorResendLink(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {resendMsgButtonName}
                      </Alert>
                    </Collapse>
                  </MDCard>
                </Card>
              </Modal>
              <Modal
                open={openEditEmailModal}
                onClose={handleCloseEditEmailModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForEdit}>
                  <MDBox ml={1} mt={-1} display="flex" alignItems="center">
                    <MDTypography
                      variant="h5"
                      fontWeight="medium"
                      flexGrow={1}
                      style={{ marginLeft: "25px" }}
                    >
                      Enter Email
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseEditEmailModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>

                  <hr style={{ marginTop: "0.5rem" }} />

                  <MDBox pt={0} pb={0} px={0}>
                    <MDBox
                      component="form"
                      role="form"
                      onSubmit={formik.handleSubmit}
                    >
                      <MDBox mb={1}>
                        <MDInput
                          type="text"
                          name="email"
                          fullWidth
                          autoComplete="off"
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          value={formik.values.email}
                          error={
                            formik.touched.email && formik.errors.email && true
                          }
                        />
                        {formik.touched.email && formik.errors.email && (
                          <TextError msg={formik.errors.email} />
                        )}
                      </MDBox>

                      <MDBox>
                        <Collapse in={isErrorForUpdate}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorForUpdate(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {updateErrorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessForUpdate}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorForUpdate(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Email updated successfully
                          </Alert>
                        </Collapse>
                      </MDBox>

                      <MDBox mt={2}>
                        <MDButton
                          variant="contained"
                          color="success"
                          type="submit"
                          fullWidth
                          disabled={
                            !formik.isValid ||
                            emailButtonName === "Please wait..."
                          }
                        >
                          {emailButtonName}
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
      {/* {!loading ? <Footer /> : null} */}
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    statusReducer: state.statusReducer,
    updateEmailReducer: state.updateEmailReducer,
    resendVendorRegistrationLinkReducer:
      state.resendVendorRegistrationLinkReducer,
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,

    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getStatus: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(getStatus(pageNo, rowsPerPage, searchObject, jwtToken)),
    updateEmail: (payload, jwtToken) =>
      dispatch(updateEmail(payload, jwtToken)),
    resendVendorRegistrationLink: (payload, jwtToken) =>
      dispatch(resendVendorRegistrationLink(payload, jwtToken)),
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(Status);
